import { handleApiErrors } from '../../../../../core/data-access/http-client/interceptors/error.interceptor';
import { FormInputConfig, AllInputTypes } from '../../../../../../trash/shared/interfaces/form-input-config';
import { FormComponent } from '../../../../../../trash/shared/components/dynamic-form/form/form.component';
import { ErrorOrError } from '../../../../../core/results/error-or/models/error-or-error.model';
import { Subscription, tap, catchError, finalize, Subject, debounceTime } from 'rxjs';
import { FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { AccountUserService } from '../../services/account-user.service';
import { ChangeDetectorRef, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { IUpdateAccountUserResponse } from '../../dtos/responses/update-account-user-response';
import { ICreateAccountUserResponse } from '../../dtos/responses/create-account-user.response';
import { ICreateAccountUserRequest } from '../../dtos/requests/create-account-user.request';
import { IUpdateUserRequest } from '../../dtos/requests/update-account-user.request';
import { getIdFormConfig } from '../../../../../../views/pages/adminstration/temp-common/utils';
import { ToastService } from '../../../../../../trash/shared/components/toasters/Toast.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'app-create-update-account-user',
    standalone: true,
    imports: [ReactiveFormsModule, CommonModule, DialogModule, ButtonModule, FormsModule, FormComponent, TranslateModule],
    templateUrl: './create-update-account-user.component.html',
    styleUrl: './create-update-account-user.component.scss'
})
export class CreateUpdateAccountUserComponent {
    private subscriptions: Subscription[] = [];

    isLoadingAddEditItem = false;
    form: FormInputConfig[] = [];
    formValues: any = null;
    accountUserId: string | undefined;
    validationErrors: any = {};
    validationEmit = false;
    systemRoles: any = [];
    selectedSystemRoleItem: any = [];
    specializedRoles: any = [];
    selectedSpecializedRoleItem: any = [];
    private searchSubject = new Subject<any>();

    constructor(
        private _accountUserService: AccountUserService,
        public dataObj: DynamicDialogConfig,
        private toastService: ToastService,
        private cdr: ChangeDetectorRef,
        private ref: DynamicDialogRef,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        this.accountUserId = this.dataObj?.data?.item?.id;
        if (this.accountUserId) {
            this.formValues = this.dataObj?.data?.item;
        }

        if (this.dataObj.data.visible && !this.accountUserId) {
            this.getAllSpecializedRoles();
            this.getAllSystemRoles();
        }
        this.initForm();

        this.searchSubject.pipe(debounceTime(1000)).subscribe((field: any) => {
            if (field.keyword.length >= 2 || field.keyword.length == 0) {
                if (field?.fieldName == 'systemRoles') {
                    this.getAllSystemRoles(field?.keyword);
                    this.selectedSystemRoleItem = this.selectedSystemRoleItem.filter(
                        (value: any, index: any, self: any) => index === self.findIndex((t: any) => t.value === value.value)
                    );
                } else if (field?.fieldName == 'specializedRoles') {
                    this.getAllSpecializedRoles(field?.keyword);
                    this.selectedSpecializedRoleItem = this.selectedSpecializedRoleItem.filter(
                        (value: any, index: any, self: any) => index === self.findIndex((t: any) => t.value === value.value)
                    );
                }
            }
        });
    }

    onFilterSelect(e: any) {
        this.searchSubject.next(e);
    }

    // Initialize the form
    initForm() {
        if (this.accountUserId) {
            // Fields for editing an existing user
            this.form = [
                getIdFormConfig(this.dataObj?.data?.item?.id),
                {
                    type: AllInputTypes.Text,
                    name: 'firstName',
                    label: this.translate.instant('FORMS.FIRST_NAME'),
                    placeholder: `${this.translate.instant('FORMS.EX')} ${this.translate.instant('FORMS.FIRST_NAME')}`,
                    defaultValue: this.formValues?.firstName,
                    isDisable: !this.dataObj?.data?.visible,
                    widthClass: 'col-12',
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.FIRST_NAME')}` }]
                },
                {
                    type: AllInputTypes.Text,
                    name: 'lastName',
                    label: this.translate.instant('FORMS.LAST_NAME'),
                    placeholder: `${this.translate.instant('FORMS.EX')} ${this.translate.instant('FORMS.LAST_NAME')}`,
                    defaultValue: this.formValues?.lastName,
                    isDisable: !this.dataObj?.data?.visible,
                    widthClass: 'col-12',
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.LAST_NAME')}` }]
                }
            ];
        } else {
            // Fields for creating a new user
            this.form = [
                getIdFormConfig(this.dataObj?.data?.item?.id),
                {
                    type: AllInputTypes.Text,
                    name: 'firstName',
                    label: this.translate.instant('FORMS.FIRST_NAME'),
                    placeholder: `${this.translate.instant('FORMS.EX')} ${this.translate.instant('FORMS.FIRST_NAME')}`,
                    defaultValue: '',
                    isDisable: false,
                    widthClass: 'col-12',
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.FIRST_NAME')}` }]
                },
                {
                    type: AllInputTypes.Text,
                    name: 'lastName',
                    label: this.translate.instant('FORMS.LAST_NAME'),
                    placeholder: `${this.translate.instant('FORMS.EX')} ${this.translate.instant('FORMS.LAST_NAME')}`,
                    defaultValue: '',
                    isDisable: false,
                    widthClass: 'col-12',
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.LAST_NAME')}` }]
                },
                {
                    type: AllInputTypes.Email,
                    name: 'email',
                    label: this.translate.instant('FORMS.EMAIL'),
                    placeholder: `${this.translate.instant('FORMS.EX')} email@email.com`,
                    defaultValue: '',
                    isDisable: false,
                    widthClass: 'col-12',
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.EMAIL')}` }]
                },
                {
                    type: AllInputTypes.MultiSelect,
                    name: 'specializedRoles',
                    label: this.translate.instant('USER_MANAGEMENT.SPECIALIZED_ROLES'),
                    placeholder: this.translate.instant('GENERAL.SELECT'),
                    widthClass: 'col-12',
                    listValues: this.specializedRoles,
                    defaultValue: this.formValues?.specializedRoles
                    // validation: [
                    //   {
                    //     function: Validators.required,
                    //     errorMessage: 'Please Select Specialized Role',
                    //   },
                    // ],
                },
                {
                    type: AllInputTypes.MultiSelect,
                    name: 'systemRoles',
                    label: this.translate.instant('USER_MANAGEMENT.SYSTEM_ROLES'),
                    placeholder: this.translate.instant('GENERAL.SELECT'),
                    widthClass: 'col-12',
                    listValues: this.systemRoles,
                    defaultValue: this.formValues?.systemRoles
                    // validation: [
                    //   {
                    //     function: Validators.required,
                    //     errorMessage: 'Please Select System Role',
                    //   },
                    // ],
                },
                {
                    type: AllInputTypes.Password,
                    name: 'password',
                    label: this.translate.instant('FORMS.PASSWORD'),
                    placeholder: `${this.translate.instant('FORMS.EX')} P@ssw0rd`,
                    widthClass: 'col-md-12',
                    defaultValue: '',
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.PASSWORD')}` }]
                },
                {
                    type: AllInputTypes.Password,
                    name: 'confirmPassword',
                    label: this.translate.instant('FORMS.CONFIRM_PASSWORD'),
                    placeholder: `${this.translate.instant('FORMS.EX')} P@ssw0rd`,
                    widthClass: 'col-md-12',
                    defaultValue: '',
                    validation: [{ function: Validators.required, errorMessage: `${this.translate.instant('GENERAL.PLEASE_ENTER')} ${this.translate.instant('FORMS.CONFIRM_PASSWORD')}` }]
                }
            ];
        }
    }
    valueChanged(data: any) {
        this.formValues = { ...data };
    }

    onClose(data?: any) {
        this.ref.close(data);
    }
    emitValidation() {
        this.validationEmit = !this.validationEmit;
        this.cdr.detectChanges();
    }

    async getAllSpecializedRoles(keyword: string = '') {
        let specializedRolesSubscription: Subscription = (await this._accountUserService.getAllSpecializedRoles({ SearchKeyword: keyword }))
            .pipe(
                tap((res: any) => this.processSpecializedRoles(res)),
                catchError((errors: ErrorOrError[]) => handleApiErrors(errors, this.toastService)),
                finalize(() => {})
            )
            .subscribe();

        this.subscriptions.push(specializedRolesSubscription);
    }
    private processSpecializedRoles(response: any): void {
        if (response) {
            let items: any = response.items;
            this.specializedRoles = items?.map((item: any) => {
                return {
                    label: item.englishName,
                    value: item.id
                };
            });
            const newItems = this.selectedSpecializedRoleItem.filter(
                (el2: any) => !this.specializedRoles.find((el1: any) => el1.value === el2.value)
            );
            // Push the new items to specializedRoles
            this.specializedRoles.push(...newItems);

            this.form[4].listValues = this.specializedRoles ? this.specializedRoles : [];
            this.cdr.markForCheck();
        }
    }

    async getAllSystemRoles(keyword: string = '') {
        let sysRolesSubscription: Subscription = (await this._accountUserService.getAllSysyemRoles({ SearchKeyword: keyword }))
            .pipe(
                tap((res: any) => this.processRolesResponse(res)),
                catchError((errors: ErrorOrError[]) => handleApiErrors(errors, this.toastService)),
                finalize(() => {})
            )
            .subscribe();

        this.subscriptions.push(sysRolesSubscription);
    }
    private processRolesResponse(response: any): void {
        if (response) {
            let items: any = response.items;
            this.systemRoles = items?.map((item: any) => {
                return {
                    label: item.englishName,
                    value: item.id
                };
            });
            const newItems = this.selectedSystemRoleItem.filter(
                (el2: any) => !this.systemRoles.find((el1: any) => el1.value === el2.value)
            );
            // Push the new items to systemRoles
            this.systemRoles.push(...newItems);
            this.form[5].listValues = this.systemRoles ? this.systemRoles : [];
            this.cdr.markForCheck();
        }
    }

    async submitForm(data: any) {
        // Check if passwords match
        if (data?.password !== data?.confirmPassword) {
            this.toastService.showError(this.translate.instant('GENERAL.VALIDATION_ERROR'), this.translate.instant('FORMS.VALIDATION_CONFIRM_PASSWORD'));
            return; // Prevent submission
        }

        this.isLoadingAddEditItem = true;
        // Determine request type
        if (this.accountUserId) {
            // Handle update request
            const updateData: IUpdateUserRequest = this.prepareUpdateDataRequest(data);
            const subscription = (await this._accountUserService.update(updateData, this.formValues.id))
                .pipe(
                    tap((res: IUpdateAccountUserResponse) => {
                        // Process response specific to update
                        this.processAddEditResponse(res, true);
                    }),
                    catchError((errors: ErrorOrError[]) => handleApiErrors(errors, this.toastService)),
                    finalize(() => {
                        this.isLoadingAddEditItem = false;
                        this.cdr.detectChanges();
                    })
                )
                .subscribe();
            this.subscriptions.push(subscription);
        } else {
            // Handle create request
            const createData: ICreateAccountUserRequest = this.prepareCreateDataRequest(data);
            const subscription = (await this._accountUserService.create(createData))
                .pipe(
                    tap((res: any) => {
                        // Process response specific to create
                        this.processAddEditResponse(res, false);
                    }),
                    catchError((errors: ErrorOrError[]) => handleApiErrors(errors, this.toastService)),
                    finalize(() => {
                        this.isLoadingAddEditItem = false;
                        this.cdr.detectChanges();
                    })
                )
                .subscribe();
            this.subscriptions.push(subscription);
        }
    }
    private prepareCreateDataRequest(data: any): ICreateAccountUserRequest {
        return {
            email: data?.email,
            firstName: data?.firstName,
            lastName: data?.lastName,
            password: data?.password,
            systemRoles: data?.systemRoles,
            specializedRoles: data?.specializedRoles
        };
    }

    private prepareUpdateDataRequest(data: any): IUpdateUserRequest {
        return {
            firstName: data?.firstName,
            lastName: data?.lastName
        };
    }
    private processAddEditResponse(response: IUpdateAccountUserResponse | ICreateAccountUserResponse, isUpdate: boolean) {
        if (isUpdate) {
            this.toastService.showSuccess(this.translate.instant('GENERAL.SUCCESS'), this.translate.instant('GENERAL.SUCCESSFULLY_UPDATED'));
        } else {
            this.toastService.showSuccess(this.translate.instant('GENERAL.SUCCESS'), this.translate.instant('GENERAL.SUCCESSFULLY_CREATED'));
        }
        this.onClose(response || true);
        this.cdr.detectChanges();
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
    }
}
